interface KPICardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: string;
  color: 'blue' | 'red' | 'green' | 'yellow';
}

const colorClasses = {
  blue: 'bg-[#EAF2F8] text-[#2F80ED]',
  red: 'bg-red-50 text-[#EF4444]',
  green: 'bg-green-50 text-[#10B981]',
  yellow: 'bg-yellow-50 text-[#EAB308]',
};

export default function KPICard({ title, value, change, trend, icon, color }: KPICardProps) {
  return (
    <div className="bg-white rounded-lg p-5 border border-gray-200 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-[#6B7280] font-medium">{title}</p>
          <p className="text-2xl font-bold text-[#0A2A43] mt-2">{value}</p>
          <div className="flex items-center gap-1 mt-2">
            <i className={`ri-arrow-${trend === 'up' ? 'up' : 'down'}-line text-sm ${trend === 'up' ? 'text-[#10B981]' : 'text-[#EF4444]'}`}></i>
            <span className={`text-xs font-semibold ${trend === 'up' ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>
              {change}
            </span>
            <span className="text-xs text-[#6B7280] ml-1">vs mes anterior</span>
          </div>
        </div>
        <div className={`w-12 h-12 rounded-lg ${colorClasses[color]} flex items-center justify-center`}>
          <i className={`${icon} text-2xl`}></i>
        </div>
      </div>
    </div>
  );
}